<!-- 提款弹框 -->
<template>
  <div class="container">
    <el-dialog center :visible.sync="dialogVisible" width="55%">
      <div class="title">我要提款</div>
      <div style="padding: 0  0.24rem">
        <p style="margin-bottom: 0.24rem;font-weight: bold;">
          提示：您确认提款成功后，请先将发票扫描后上传至系统，之后寄往如下地址（电子票请直接上传）：
          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX XXXXXXXXXXXXXXX
          。在收到与提款金额一致的发票后，平台将在三至五个工作日内完成转账！
        </p>
        <el-form ref="ruleForm" label-width="120px">
          <el-form-item prop="name" label="我可提款余额：">
            <span style="color: red; margin-right: 0.36rem">¥{{ datas.balance }}</span>
            <!-- <span>不可提现余额为： <span style="color: red; margin-right: 0.36rem">¥{{ datas.lockBalance }}</span></span>  -->
            <span>说明：您的账户内￥200为奖励金，不可提款，可用于购买会员等级、优惠券或积分等使用</span>
          </el-form-item>
          <el-form-item prop="name" label="不可提款余额：">
            <span style="color: red; margin-right: 0.36rem">¥{{ datas.lockBalance }}</span>
          </el-form-item>
          <el-form-item prop="name" label="本次提款金额：">
            <el-input :disabled="datas.balance <= 0" v-model="datas.withdrawaPrice" size="small" style="width: 2rem;margin-right: 0.24rem;" placeholder="请输入提现金额"></el-input>
            <el-button :disabled="datas.balance <= 0" @click="handlerWithdrawalClick" class="btns" size="small" type="primary">全部提现</el-button>
          </el-form-item>
          <el-form-item prop="name" label="提款方式：">
            <span style="font-weight: bold;">汇款</span>
          </el-form-item>
          <el-form-item prop="name" label="账号信息：">
            <p>浙商银行 1000******************6376</p>
            <p>说明：若您需要更改账户信息，请联系贵司管理员在"商户管理"-"商户入驻资料维护"这个页面内修改银行信息</p>
          </el-form-item>
        </el-form>
      </div>
      <el-button :disabled="withdrawaPrice <= 0" class="btns" size="small" slot="footer" type="primary" @click="dialogVisible = false">确认提款</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      current: "",
      withdrawaPrice: 0,//提现金额
      datas: {}
    };
  },
  computed: {
  },
  watch: {},
  methods: {
    initClick(val) {
      console.log(val, '上课的考试考的');
      this.datas = val
      this.dialogVisible = true
    },
    //提现
    handlerWithdrawalClick() {
      if (this.datas.balance > 0) {
        this.withdrawaPrice = this.datas.balance
      } else {
        this.$message({
          message: '暂无提现余额',
          type: 'warning'
        });
      }
    }

  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-dialog__footer {
  padding-bottom: 0.24rem !important;
}

/deep/ .el-dialog__headerbtn {
  top: 10 !important;
}

.container {
  .btns {
    color: #3C8076;
    background-color: #E5F5F3;
    border-color: #E5F5F3;
  }

  .active {
    background-color: var(--color) !important;
    color: #fff !important;
  }

  .title {
    height: 0.5rem;
    background-color: #E5F5F3;
    color: #000;
    padding-left: 0.24rem;
    text-align: left;
    line-height: 0.5rem;
    margin-bottom: 0.24rem;
  }

  .btnBox {
    display: flex;
    align-items: center;
  }
}
</style>
